import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        updating: false,
        loadingGroup: true,
        name: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadGroup = instance => {
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/journal/group",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data : {
            id: instance.props.match.params.id,
            Authorization: store.getState().auth.authorization
        }
    }).then(response => handleLoadGroupResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadGroupResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingGroup: false,
                name: response.data.data.group.name,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 300, error: "Too long" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const updateGroup = (instance) => {
    instance.setState({
        ...instance.state,
        updating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/journal/group/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            name: instance.state.name,
            Authorization: store.getState().auth.authorization
        }
    }).then(response => handleUpdateGroupResponse(instance, response))
        .catch(error => alert(error))
}

const handleUpdateGroupResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "success",
                    text: "Group Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const EditGroupWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        loadGroup: () => loadGroup(instance),
        isValid: () => isValid(instance),
        updateGroup: () => updateGroup(instance)
    }
}

export default EditGroupWorker